import { useId } from 'react';

interface ISparklineProps {
  valores: number[];
  cor: string;
  altura?: number;
}

// Mini gráfico de linha (SVG puro, sem lib de gráficos) pros cards de
// cotação — só a tendência, sem eixos. Estica na largura do container.
export const Sparkline: React.FC<ISparklineProps> = ({ valores, cor, altura = 34 }) => {
  const idGradiente = useId();
  if (valores.length < 2) return <svg width="100%" height={altura} />;

  const minimo = Math.min(...valores);
  const maximo = Math.max(...valores);
  const faixa = maximo - minimo || 1;
  const margem = 2;
  const pontos = valores.map((valor, indice) => {
    const x = (indice / (valores.length - 1)) * 100;
    const y = margem + (1 - (valor - minimo) / faixa) * (altura - margem * 2);
    return `${x.toFixed(2)},${y.toFixed(2)}`;
  });

  return (
    <svg width="100%" height={altura} viewBox={`0 0 100 ${altura}`} preserveAspectRatio="none" style={{ display: 'block' }}>
      <defs>
        <linearGradient id={idGradiente} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={cor} stopOpacity={0.28} />
          <stop offset="100%" stopColor={cor} stopOpacity={0} />
        </linearGradient>
      </defs>
      <polygon points={`0,${altura} ${pontos.join(' ')} 100,${altura}`} fill={`url(#${idGradiente})`} />
      <polyline
        points={pontos.join(' ')}
        fill="none"
        stroke={cor}
        strokeWidth={1.6}
        strokeLinejoin="round"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
};
